import { render, staticRenderFns } from "./ModalHoliday.vue?vue&type=template&id=58fd6f5a&scoped=true&"
import script from "./ModalHoliday.vue?vue&type=script&lang=js&"
export * from "./ModalHoliday.vue?vue&type=script&lang=js&"
import style0 from "./ModalHoliday.vue?vue&type=style&index=0&id=58fd6f5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fd6f5a",
  null
  
)

export default component.exports